import _Collapse from './Collapse';
import _CollapsePanel from './CollapsePanel';

import './style/index.js';

export type { CollapseProps } from './Collapse';
export type { CollapsePanelProps } from './CollapsePanel';

export * from './type';

export const Collapse = _Collapse;
export const CollapsePanel = _CollapsePanel;
